import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import CsLineIcons from 'cs-line-icons/CsLineIcons';
import { Row, Col, Button, Card, Badge, Dropdown } from 'react-bootstrap';
import { observer } from 'mobx-react';
import { ContestantUserBaseModel, EventModel } from 'API/Generated/data-contracts';
import { useHistory } from 'react-router-dom';
import { GetPageantStore } from 'SessionState/Pageant/PageantStore';
import ImageRender from 'views/components/ImageRender';
import { sanitizeForURL } from 'helpers/Helpers';
import { GetContestantStore } from 'SessionState/Contestant/ContestantStore';
import { calcAgeAsOfYearsMonths } from 'helpers/DateHelper';


const ContestantIconCard = (props: { contestantUser: ContestantUserBaseModel }) => {
  const history = useHistory();
  const pageantStore = GetPageantStore();
  const contestantStore = GetContestantStore();
  const containerName = 'contestant-profile-headshots';

  const navigateToContestantUserProfile = () => {
    // contestantStore.resetCurrentUser();
    if (props.contestantUser?.id) {
      contestantStore.getContestant(props.contestantUser.id);
      history.push(`/contestant/profile`);
    }
  }

  return (
    <>
      {/* Event Icon Card Start */}
      <Link to={`/contestant/profile`} onClick={navigateToContestantUserProfile} className="text-center text-body text-small">
          <span className='text-center justify-content-center align-content-center'>
          <ImageRender src={props?.contestantUser?.profilePic?.image} containerName={containerName}   alt={props?.contestantUser?.firstName || 'Contestant Headshot'} className="profile rounded-circle sh-8 sw-8 m-auto mb-2" /> 
          </span>
          {/* Event Details Start */}
            <div className="mb-0 text-center d-block fw-bold cardHeading">
              {props?.contestantUser?.firstName}  {props.contestantUser?.lastName?.slice(0, 1)}
            </div>
            <div className="text-muted">{calcAgeAsOfYearsMonths(props.contestantUser?.birthday, new Date(Date.now()))}</div>
          {/* Event Details End */}
        </Link>
      {/* Event Icon Card End */}
      </>
  );
};

export default ContestantIconCard;
